/* ==========================================================================
   GUIA DE MEDIDAS — abertura/fechamento do modal  ·  20/08/2026
   --------------------------------------------------------------------------
   POR QUE DELEGACAO NO DOCUMENT, E NAO querySelectorAll NO LOAD
     O Shopify re-renderiza a secao do produto na troca de variante. Listener
     preso ao elemento morre junto com o nó antigo; delegado ao document,
     sobrevive a qualquer re-render.

   POR QUE <dialog> NATIVO
     showModal() ja entrega ESC, foco preso e ::backdrop, e promove o elemento
     ao TOP LAYER — o que faz o modal escapar do overflow:hidden / max-height:0
     do acordeao "Medidas da Armacao" onde o botao vive. Sem biblioteca.

   TRAVA DE SCROLL
     position:fixed + top:-scrollY no body. So overflow:hidden nao segura o
     iOS. Ao fechar, a posicao e restaurada — sem isso o Safari joga a cliente
     de volta para o topo da pagina.
   ========================================================================== */
(function () {
  if (window.__rcGuiaMedidas) return;
  window.__rcGuiaMedidas = true;

  var scrollY = 0;
  var travado = false;

  function travarFundo() {
    if (travado) return;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -scrollY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    travado = true;
  }

  function destravarFundo() {
    if (!travado) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    travado = false;
    window.scrollTo(0, scrollY);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // Abrir
    var gatilho = e.target.closest('[data-rc-guia-abrir]');
    if (gatilho) {
      var alvo = document.getElementById(gatilho.getAttribute('data-rc-guia-abrir'));
      if (alvo && typeof alvo.showModal === 'function' && !alvo.open) {
        e.preventDefault();
        // O clique nasce dentro do acordeao; sem isto o header do acordeao
        // recebe o mesmo clique e fecha o painel embaixo do modal.
        e.stopPropagation();
        alvo.showModal();
        travarFundo();
      }
      return;
    }

    // Fechar pelo X
    var fechar = e.target.closest('[data-rc-guia-fechar]');
    if (fechar) {
      var dlg = fechar.closest('dialog.rc-guia');
      if (dlg && dlg.open) dlg.close();
      return;
    }

    // Fechar clicando no backdrop: o <dialog> preenche a tela e o painel fica
    // dentro dele, entao o clique fora do painel tem o proprio dialog no alvo.
    if (e.target.matches && e.target.matches('dialog.rc-guia') && e.target.open) {
      e.target.close();
    }
  });

  // 'close' nao borbulha — a fase de CAPTURA alcanca o alvo mesmo assim.
  // Cobre o X, o backdrop e o ESC (que dispara cancel -> close) num lugar so.
  document.addEventListener(
    'close',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('dialog.rc-guia')) {
        destravarFundo();
      }
    },
    true
  );
})();
